<template>
    <div v-wechat-title="title" class="background"
        :style="{ background: config.BoardConfigBakColor, '--rowcolor':config.BoardConfigTimeFontColor }">
        <div class="header" :style="{
                height: `${config.BoardConfigLogoHeaderHeight || '100'}px`,
                background: config.BoardConfigLogobgColor || ''
            }">
            <div class="logo">
                <!-- <img src="../../assets/logo/福建二院logo.png" /> -->
                <img :src="Logo" />
                <span :style="{
                        color: config.BoardConfigTimeFontColor || '',
                        fontSize: `${BoardType == 0 ? config.BoardConfigTimeFontSize * xn : config.BoardSchduleConfigTimeFontSize * xn}px`
                    }">{{ config.HospitalName }}</span>
            </div>
            <div class="time"
                :style="{ color: config.BoardConfigTimeFontColor || '', fontSize: `${BoardType == 0 ? config.BoardConfigTimeFontSize * xn : config.BoardSchduleConfigTimeFontSize * xn}px` }">
                {{ nowtime }}
            </div>
        </div>
        <el-row v-show="headText && headText.length>0" class="align-center line-height100 padding5" v-html="headText">
        </el-row>
        <div>
            <div v-if="configs.length > 0">
                <table class="table">
                    <tr v-for="(item, index) in _rows" :key="index" class="content" :style="{
                            color: FontColor((item.enum_surgery_status && item.enum_surgery_status.label) || ``),
                            backgroundColor: RowBackColor((item.enum_surgery_status && item.enum_surgery_status.label) || ``)
                        }">
                        <td v-for="(value, key) in item" :key="key" :style="getstyle(value)">
                            <div :style="getdivstyle(index, value, _rows[0][key])">
                                <marquee v-if="value.is_roll" behavior="scroll" direction="left" scrolldelay="100">{{
                                    value.label }}</marquee>
                                <span v-else>{{ value.label }}</span>
                            </div>
                            <!-- <div
                                :style="{
                                    height: '120px',
                                    lineHeight: '40px',
                                    '-webkit-line-clamp': 3
                                }"
                            >
                                {{ value.label }}
                            </div> -->
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-if="is_show" class="text-show">
            <marquee behavior="scroll" direction="left" scrollamount="8" scrolldelay="100">{{ content.Content }}
            </marquee>
        </div>
    </div>
</template>

<script>
export default {
    name: `Board`,
    props: {
        rows: { type: Array },
        columns: { type: Array },
        span: Number,
        title: String,
        BoardType: { type: Number, default: 0 }, // 0-家属屏  1-排程屏
        roomIds: { type: Array },
        bedIds: { type: Array },
        BoardNo: { type: String, default: `0` } // 大屏编号
    },
    data() {
        return {
            time: this.$moment().format(`YYYY年MM月DD日 HH:mm`),
            pushRow: 0,
            headText: ``,
            nowtime: ``,
            config: {
                boardConfigPageInterval: 10,
                boardConfigFamilyPrivate: true,
                boardConfigFontSize: 30,
                boardConfigAudio: ``,
                hosptialName: ``,
                boardLineHeight: ``,
                boardConfigHeaderHeight: ``,
                boardConfigBakColor: ``,
                boardConfigRowBackColor: ``,
                BoardConfigFontColor: ``,
                boardConfigTimeFontColor: ``, // 右上角显示日期时间的字体颜色
                boardConfigTimeFontSize: ``, // 头部公司名称的字体大小
                boardSchduleConfigTimeFontSize: ``, // 排程屏头部公司名称的字体大小
                boardConfigLogoHeaderHeight: ``, // 电子屏头部Logo高度配置
                BoardConfigLogo: ``,
                BoardConfigBorderColor: ``,
                BoardConfigLogobgColor: ``,
                BoardConfigSchduleScroll: ``,
                BoardConfigFamilyScroll: ``
            },
            xn: 1,
            configs: [],
            keys: [
                `BoardConfigAudio`,
                `BoardConfigPageInterval`,
                `BoardConfigFamilyPrivate`,
                `BoardConfigRemainBuffer`,
                `BoardConfigFontSize`,
                `BoardPageCount`,
                `BoardLineHeight`,
                `BoardConfigHeaderHeight`,
                `BoardIP`,
                `BoardConfigBakColor`,
                `BoardConfigRowBackColor`,
                `BoardConfigLogo`,
                `BoardConfigFontColor`,
                `BoardConfigTimeFontColor`,
                `BoardConfigTimeFontSize`, // 头部公司名称的字体大小
                `BoardSchduleConfigTimeFontSize`, // 排程屏头部公司名称的字体大小
                `BoardConfigLogoHeaderHeight`, // 电子屏头部Logo高度配置
                `HospitalName`,
                `BoardSchduleConfigPageInterval`,
                `BoardSchduleConfigFontSize`,
                `BoardSchdulePageCount`,
                `BoardSchduleLineHeight`,
                `BoardConfigContent`,
                `BoardConfigBorderColor`,
                `BoardConfigLogobgColor`,
                `BoardConfigSchduleScroll`,
                `BoardConfigFamilyScroll`
            ],
            content: {},
            is_show: false,
            BoardSurgerytypeColor: this.$root.BoardSurgerytypeColor,
            BoardSurgerytypeColorObj: null,
            BoardColumnbgColorBySurgeryStatus: this.$root.BoardColumnbgColorBySurgeryStatus,
            BoardColumnbgColorBySurgeryStatusObj: null,
            BoardHeadConfig: this.$root.BoardHeadConfig,
            headerColumns: [],
            roomIdsStr: ``,
            bedIdsStr: ``,
            scrolltimer: `` // 自动滚动的定时任务
        }
    },
    created() {
        this.loadConfigs()
        // this.timer()
        this.init().then(() => {
            this.startScroll()
            this.isShow().then(data => {
                this.is_show = data
            })
        })

        if (document.documentElement.clientWidth > 1024) {
            this.xn = 2
        } else {
            this.xn = 1
        }
        if (this.BoardHeadConfig && _.includes(this.BoardHeadConfig.trim().toLowerCase(), `proc_`)) {
            this.loadBoardHeadConfig()
        }
    },
    mounted() {
    },
    computed: {
        // nowtime: {
        //     get: function() {
        //         return this.time
        //     },
        //     set: function(v) {
        //         this.time = v
        //     }
        // },
        FontColor() {
            if (this.config.BoardConfigFontColor == ``) return () => { }
            let fontConfigs = JSON.parse(this.config.BoardConfigFontColor)
            return item => {
                let color = ``
                for (let config of fontConfigs) {
                    if (config.value == item) {
                        color = config.color
                    }
                }
                return color
            }
        },
        // added by xiaorui
        // date:2021-08-27
        // 根据状态设置行背景色
        RowBackColor() {
            return item => {
                // 没有设置默认=整个电子屏的背景色
                let rowBackColor = this.config.BoardConfigRowBackColor || ``
                if (item == `` || rowBackColor == ``) return ``
                let fontConfigs = JSON.parse(this.config.BoardConfigRowBackColor)
                let color = ``
                for (let config of fontConfigs) {
                    if (config.value == item) {
                        color = config.color
                    }
                }
                return color
            }
        },
        Logo() {
            return `../../../static/img/${this.config.BoardConfigLogo || `logo_white.png`}`
        },
        _rows() {
            if (this.configs.length == 0) return []
            let list = this.rows
            let arr = []
            let items = []
            let that = this
            if (that.BoardType === 0) {
                that.configs = _.filter(that.configs, d => {
                    return d.is_show && d.type == 0
                })
            } else {
                that.configs = _.filter(that.configs, d => {
                    return d.is_show && d.type == 1
                })
            }
            if (list.length > 0) {
                let titleObj = null
                for (let obj of list) {
                    let r = ``
                    let t = ``
                    for (let c of that.configs) {
                        let info = `"${c.value}":{"label":"${obj[c.value] && obj[c.value].toString().replace(/"/g, `'`)}","span":${c.width},"display_order":"${c.display_order}","is_roll":${c.is_roll}}`
                        // modify by xiaorui,加了display_back_color列，列头背景色就显示背景色，没有设置就显示行的背景色
                        let title = `"${c.value}":{"label":"${c.name}","span":${c.width},"display_order":"0","display_back_color":"${c.display_back_color}","is_roll":false,"header_style":[${c.header_style}],"column_style":[${c.column_style}]}`
                        r = `${r + info},`
                        t = `${t + title},`
                    }
                    let config = JSON.parse(`{${r.substring(0, r.length - 1)}}`)
                    titleObj = JSON.parse(`{${t.substring(0, t.length - 1)}}`)
                    // 如果配置的列中，没有手术状态列，加一个状态的隐藏列用于判断行背景色
                    let index = _.has(titleObj, `enum_surgery_status`)
                    if (!index) {
                        titleObj.enum_surgery_status = {
                            label: `手术状态枚举`,
                            span: 0,
                            display_order: `0`,
                            display_back_color: `#FF8C00`
                        }
                    }

                    let index1 = _.has(config, `enum_surgery_status`)
                    if (!index1) {
                        config.enum_surgery_status = {
                            label: `${obj[`enum_surgery_status`]}`,
                            span: 0,
                            display_order: `0`,
                            display_back_color: `#FF8C00`
                        }
                    }
                    if (that.BoardSurgerytypeColorObj != null) {
                        let index2 = _.has(config, `surgery_type`)
                        if (index2 && config.surgery_type.label != ``) {
                            config.surgery_type.color = that.BoardSurgerytypeColorObj[config.surgery_type.label]
                        }
                    }
                    if (that.BoardColumnbgColorBySurgeryStatusObj != null) {
                        let index2 = _.has(config, `current_key_event`)
                        if (index2 && config.current_key_event.label != ``) {
                            config.current_key_event.display_back_color = that.BoardColumnbgColorBySurgeryStatusObj[config.current_key_event.label]
                        }
                        let index3 = _.has(config, `surgery_status`)
                        if (index3 && config.surgery_status.label != ``) {
                            config.surgery_status.display_back_color = that.BoardColumnbgColorBySurgeryStatusObj[config.surgery_status.label]
                        }
                    }

                    arr.push(config)
                }
                if (titleObj !== null) {
                    items.push(titleObj)
                }
            } else {
                let t2 = ``
                for (let c2 of that.configs) {
                    // modify by xiaorui,加了display_back_color列，列头背景色就显示背景色，没有设置就显示行的背景色
                    let title2 = `"${c2.value}":{"label":"${c2.name}","span":${c2.width},"display_order":"0","display_back_color":"${c2.display_back_color}"}`
                    if (c2.header_style) {
                        title2 += `,"header_style":[${c2.header_style}]`
                    }
                    if (c2.column_style) {
                        title2 += `,"column_style":[${c2.column_style}]`
                    }
                    t2 = `${t2 + title2},`
                }
                let titleObj2 = JSON.parse(`{${t2.substring(0, t2.length - 1)}}`)
                if (titleObj2 !== null) {
                    items.push(titleObj2)
                }
            }
            return items.concat(arr)
        },
        _BoardNo() {
            if (!this.config.BoardConfigContent) return
            let isShow = false
            let now = new Date()
            let day = now.getDay()
            let boardConfigContent = JSON.parse(this.config.BoardConfigContent)
            this.content = boardConfigContent
            let startTime = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${boardConfigContent.startTime}`)
            let endTime = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${boardConfigContent.endTime}`)
            let weeks = boardConfigContent.week.split(`|`)
            if (boardConfigContent.BoardNo == this.BoardNo && weeks.indexOf(day.toString()) != -1 && now >= startTime && now <= endTime) {
                isShow = true
            }
            return isShow
        }
    },
    methods: {
        loadBoardHeadConfig() {
            let that = this
            // var textInfo = `<div class="el-col el-col-24" style="text-align: right;">
            //     <i style="background: #009688;width: 25px;height: 16px;border: #656565 solid 1px;display: inline-block;vertical-align: middle;"></i>&nbsp;<span style="font-size: 32;color: white;">当天手术量(20)</span>
            //     <i style="background: #009688;width: 25px;height: 16px;border: #656565 solid 1px;display: inline-block;vertical-align: middle;"></i>&nbsp;<span style="font-size: 32;color: white;">当天手术量(20)</span>
            //     <i style="background: #009688;width: 25px;height: 16px;border: #656565 solid 1px;display: inline-block;vertical-align: middle;"></i>&nbsp;<span style="font-size: 32;color: white;">当天手术量(20)</span>
            //     <i style="background: #009688;width: 25px;height: 16px;border: #656565 solid 1px;display: inline-block;vertical-align: middle;"></i>&nbsp;<span style="font-size: 32;color: white;">当天手术量(20)</span>
            // </div>`
            try {
                that.roomIdsStr = that.roomIds && that.roomIds.join(`,`) || ``
                that.bedIdsStr = that.bedIds && that.bedIds.join(`,`) || ``
                let req = that.myaxios.get(`/api/Operation/BoardNotice/GetBoardHeadConfig?boardType=${this.BoardType}&&roomIds=${this.roomIdsStr}&&bedIds=${this.bedIdsStr}`)
                req.then(data => {
                    that.headText = data || ``
                })
            } catch (e) {
                that.headText = ``
            }
        },
        startScroll() {
            let that = this
            let BoardConfigScroll = 0
            console.log(`BoardConfigSchduleScroll`, this.config.BoardConfigSchduleScroll)
            console.log(`BoardConfigFamilyScroll`, this.config.BoardConfigFamilyScroll)
            if (that.BoardType === 0) { // 家属屏
                BoardConfigScroll = parseInt(this.config.BoardConfigFamilyScroll || `0`)
            } else {
                BoardConfigScroll = parseInt(this.config.BoardConfigSchduleScroll || `0`)
            }
            if (BoardConfigScroll > 0) {
                setInterval(() => {
                    const allcount = this.rows.length
                    if (that.pushRow < allcount) {
                        that.pushRow++
                        const removeItems = this.rows.splice(0, 1) // 移除元素
                        this.rows.push(...removeItems) // 将它们添加到数组末尾
                    } else {
                        this.$emit(`loadList`)
                    }
                }, BoardConfigScroll * 1000)
            }
        },
        init() {
            console.log(`BoardSurgerytypeColor`, this.BoardSurgerytypeColor)
            if (this.BoardSurgerytypeColor != ``) {
                this.BoardSurgerytypeColorObj = JSON.parse(this.BoardSurgerytypeColor)
                console.log(`BoardSurgerytypeColor2`, this.BoardSurgerytypeColorObj)
            }

            console.log(`BoardColumnbgColorBySurgery`, this.BoardColumnbgColorBySurgeryStatus)
            if (this.BoardColumnbgColorBySurgeryStatus != ``) {
                this.BoardColumnbgColorBySurgeryStatusObj = JSON.parse(this.BoardColumnbgColorBySurgeryStatus)
                console.log(`BoardColumnbgColorBySurgeryStatus2`, this.BoardColumnbgColorBySurgeryStatusObj)
            }

            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/Get`)
                let obj = {}
                req.then(data => {
                    let boards = _.filter(data, d => {
                        return this.keys.indexOf(d.key) > -1
                    })
                    for (let board of boards) {
                        obj[board.key] = board.value
                    }
                    this.config = obj
                    this.$emit(`init`, this.config)
                    resolve()
                })
            })
        },
        getstyle(value) {
            if (value.header_style && value.header_style.length > 0 && value.header_style[0] != null) {
                var style = value.header_style[0]
                style.width = `${(value.span / 24) * 100}%`
                style.display = `${value.span == 0 ? `none` : `table-cell`}`
                // style[`justify-content`] = style[`justify-content`] || `center`
                return value.header_style[0]
            } else {
                return {
                    width: `${(value.span / 24) * 100}%`,
                    border: `1.5px solid ${this.config.BoardConfigBorderColor || `red`}`,
                    display: `${value.span == 0 ? `none` : `table-cell`}`,
                    fontSize: `${this.BoardType == 0 ? this.config.BoardConfigFontSize * this.xn : this.config.BoardSchduleConfigFontSize * this.xn}px`,
                    backgroundColor: value.display_back_color || ``, // 设置了列头背景色就显示背景色，没有设置就显示行的背景色
                    color: value.color || ``
                }
            }
        },
        getdivstyle(index, value, all) {
            let that = this
            let style = {}
            if (index !== 0 && all.column_style && all.column_style.length > 0 && all.column_style[0] != null) {
                style = all.column_style[0]
            } else {
                style = {
                    'overflow': `hidden`,
                    'text-overflow': `ellipsis`,
                    'display': `-webkit-flex`,
                    'align-items': `center`,
                    'justify-content': `center`
                }
            }
            style.height = `${index === 0 ? that.config.BoardConfigHeaderHeight : that.BoardType == 0 ? that.config.BoardLineHeight : that.config.BoardSchduleLineHeight}px`

            return style
        },
        // timer() {
        //     return setInterval(() => {
        //         this.time = this.$moment().format(`YYYY年MM月DD日 HH:mm`)
        //         this.isShow().then(data => {
        //             this.is_show = data
        //         })
        //     }, 10000)
        // },
        loadConfigs() {
            let req = this.myaxios.get(`/api/AcisSystem/BoardConfig/Get`)
            req.then(data => {
                this.configs = data
                console.log(this.configs)
            }).catch(e => {
                console.log(e)
            })
        },
        isShow() {
            return new Promise(resolve => {
                if (!this.config.BoardConfigContent) return
                let isShow = false
                let now = new Date()
                let day = now.getDay()
                let boardConfigContent = JSON.parse(this.config.BoardConfigContent)
                this.content = boardConfigContent
                let startTime = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${boardConfigContent.startTime}`)
                let endTime = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} ${boardConfigContent.endTime}`)
                let weeks = boardConfigContent.week.split(`|`)
                if (boardConfigContent.BoardNo == this.BoardNo && weeks.indexOf(day.toString()) != -1 && now >= startTime && now <= endTime) {
                    isShow = true
                }
                resolve(isShow)
            })
        }
    },
    destroyed() {
        // clearInterval(this.timer)
    },
    watch: {
        is_show(newValue) {
            console.log(newValue)
            if (this.is_show == !newValue) {
                // location.reload()
                this.is_show = newValue
            }
        }
    }
}
</script>

<style scoped>
    .background {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #1f2d3d;
    }

    .header {
        position: relative;
        top: 0;
        border-left: 1.5px solid #ffffff;
        border-right: 1.5px solid #ffffff;
        border-bottom: 1.5px solid #ffffff;
        overflow: hidden;
    }

    .logo {
        float: left;
        font-size: 30px;
        color: #ffffff;
        width: 65%;
        height: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .logo span {
        float: left;
        width: 65%;
        max-width: 65%;
        text-align: left;
        box-sizing: border-box;
        padding: 0 10px;
        max-height: 95%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
        justify-content: left;
        height: 95%;
        line-height: 95%;
    }

    .logo img {
        float: left;
        width: auto;
        height: auto;
        max-width: 90%;
        max-height: 95%;
        box-sizing: border-box;
        padding: 5px;
    }

    .time {
        float: right;
        color: #ffffff;
        overflow: hidden;
        white-space: nowrap;
        height: 95%;
        line-height: 95%;
        width: 35%;
        text-align: right;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
    }

    .footer {
        position: relative;
        bottom: 0;
        background-color: var(--primary-color, #009688);
        height: 60px;
    }

    /* .height{
    height: 100px !important;
    border-bottom: 1px solid #ffffff;
  } */
    .content {
        color: #ffffff;
        /* height: 100px; */
        border-bottom: 5px solid #ffffff;
        /* line-height: 100px; */
    }

    .ellipsis1 {
        display: inline-block;
        overflow: hidden;
        width: 100%;
    }

    .text-show {
        color: var(--rowcolor);
        font-size: 50px;
        margin: 0 auto;
        height: 60px;
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
    }

    .table {
        width: 100%;
        table-layout: fixed;
        border-spacing: 0px;
    }

    .table td {
        /* padding: 3px;
    text-align: center; */
        /* text-overflow: ellipsis; */
        word-wrap: break-word;
    }

            /* text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical; */
    /* .table td div {

        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
    } */
</style>



// WEBPACK FOOTER //
// src/components/Board/Board.vue